import React from 'react';
import { Text } from 'react-native-elements';
import { StyleSheet } from 'react-native';

import { type LanguageText } from '../types/Language';
import { useLanguage } from '../context/LanguageContext';

const styles = StyleSheet.create({
    horizontalText: {
        textAlign: 'left',
        fontSize: 16,
        marginVertical: 10,
        width: '50%',
    },
});

interface TextProps {
    data: string | number | LanguageText;
}

const TextField: React.FC<TextProps> = ({ data }) => {
    const { currentLanguage } = useLanguage();

    return (
        <Text style={styles.horizontalText}>
            {typeof data === 'string' || typeof data === 'number'
                ? data
                : data[currentLanguage]}
        </Text>
    );
};

export default TextField;
